import {
  ScaffolderFormPaper,
  ScaffolderInputHeader,
  ScaffolderFormHeader,
  ScaffolderFieldError,
} from '@internal/plugin-scaffolder-common-field-react';
import React, { useEffect, useRef } from 'react';

import { Box, TextField } from '@material-ui/core';

import { APPSET_APP_NAME } from '../infoDoc';
import { useStyles } from '../styles';
import { validateAppSetTemplatePattern } from '../validation';

interface ApplicationSetAppNameTemplateSectionProps {
  value: string;
  onChange: (value: string) => void;
  errors: string[];
}

const ApplicationSetAppNameTemplateSectionInner = ({
  value,
  onChange,
  errors,
}: ApplicationSetAppNameTemplateSectionProps) => {
  const classes = useStyles();
  const sectionRef = useRef<HTMLDivElement>(null);
  const templatePatchError =
    errors.length > 0 &&
    (!value || !value.trim() || !validateAppSetTemplatePattern(value))
      ? 'Application name template is required and must be a valid template expression.'
      : '';

  useEffect(() => {
    if (templatePatchError) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [templatePatchError]);

  return (
    <div ref={sectionRef}>
      <ScaffolderFormPaper>
        <ScaffolderFormHeader
          title="Application"
          description="Application Name which will be used in the ApplicationSet."
          divider
        />
        <Box>
          <Box className={classes.inputContainer}>
            <ScaffolderInputHeader
              title="Templated Application Name"
              description="Specify the name of the application to be created."
              infoDoc={APPSET_APP_NAME}
            />
            <TextField
              label="Templated Application Name"
              variant="outlined"
              margin="none"
              color="secondary"
              size="small"
              fullWidth
              required
              value={value}
              onChange={e => onChange(e.target.value)}
              error={Boolean(templatePatchError)}
              helperText={
                Boolean(templatePatchError) ? (
                  <ScaffolderFieldError message={templatePatchError} />
                ) : (
                  ''
                )
              }
            />
          </Box>
        </Box>
      </ScaffolderFormPaper>
    </div>
  );
};

export const ApplicationSetAppNameTemplateSection = React.memo(
  ApplicationSetAppNameTemplateSectionInner,
);
